import { render, staticRenderFns } from "./TagNew.vue?vue&type=template&id=eb237baa&scoped=true&"
import script from "./TagNew.vue?vue&type=script&lang=js&"
export * from "./TagNew.vue?vue&type=script&lang=js&"
import style0 from "./TagNew.vue?vue&type=style&index=0&id=eb237baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb237baa",
  null
  
)

export default component.exports